<template>
  <v-toolbar dark color="#6a1b9a" class="topbar">
    <v-toolbar-title
      class="gagalin-font"
      style="padding-left:10px; font-size:36px;"
    >
      Curriculum Access
    </v-toolbar-title>

    <!-- spacer pushes the search to the right -->
    <v-spacer />

    <!-- your search field -->
    <v-text-field
      v-model="search"
      label="Search for Files"
      append-icon="mdi-magnify"
      single-line
      hide-details
      @input="$emit('search', search)"
      style="padding-right:20px;"
    />

    <!-- absolutely‐positioned center button -->
    <v-btn
      class="center-btn text-black font-weight-bold"
      color="white"
      variant="outlined"
      @click="goBack"
    >
      Exit Curriculum Access
      <v-icon left>mdi-close</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
export default {
  name: "TopBar",
  data: () => ({
    search: "",
  }),
  methods: {
    goBack() {
      window.location.assign('https://truerobotics.org/curriculum-access');
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: "Gagalin";
  src: url("~@/assets/fonts/Gagalin-Regular.ttf") format("truetype");
}

.gagalin-font {
  font-family: "Gagalin", sans-serif;
}

/* pull the button out of flex and center it */
.center-btn {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
</style>
